module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sextans/sex_rn-cfe5e68a2837b903eec2eeaa062d1fc5.gif";